const styles = theme => ({
  overlay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    position: 'fixed',
    zIndex: 1100,
    backgroundColor: '#0000009e',
    backdropFilter: 'blur(5px)',
    overflow: 'hidden',
    boxShadow: '0px 4px 16px 0px rgb(145 158 171 / 12%)',
  },
  draggable: {
    backdropFilter: 'none',
    backgroundColor: 'transparent',
    overflow: 'visible',
    width: 'unset',
    height: 'unset',
  },
  dragLine: {
    marginBottom: '12px',
    width: '60px',
    height: '0px',
    borderTop: '3px solid var(--Gray-Main, #CBD0D7)',
    margin: '0 auto',
    cursor: 'grab',
  },
  box: {
    width: 'fit-content',
    padding: '20px',
    borderRadius: '16px',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    boxShadow: '0px 4px 16px 0px rgb(145 158 171 / 12%)',

    // Remove position: relative if it exists
  },
  boxDraggable: {
    width: 'fit-content',
    padding: '10px 20px 20px 20px',
    borderRadius: '16px',
    backgroundColor: '#fff',
    minWidth: '240px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    boxShadow: '0px 4px 16px 0px rgb(145 158 171 / 32%)',
  },
  // ... rest of your styles

  subTitleStyle: {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Inter',
  },
  descriptionStyle: {
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'Inter',
  },
  noteStyle: {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Inter',
    color: '#ED4245',
  },
})

export default styles
